import React from 'react'
import FormContainer from "../../../components/CommonComponents/FormContainer";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import { useState, useRef, useEffect } from 'react';
import { useMyContext } from '../../../components/Provider/CommonProvider';
import { toast } from 'react-toastify';
import Select from "react-select";
import Defaultloadinggif from '../../../layout/Others/Defaultloadinggif';
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader';
import MessageHeading from '../../../components/CommonComponents/MessageHeading';
import AdminCustomSelect from '../../../components/CommonComponents/AdminCustomSelect';
import RightWrapper from '../../../components/CommonComponents/RightWrapper';
import MessageLabel from '../../../components/CommonComponents/MessageLabel';
import AdminCustomInput from '../../../components/CommonComponents/AdminCustomInput';
import MessageBox from '../../../components/CommonComponents/MessageBox';
import Response_Processing from '../../../layout/Others/Response_Processing';

const Playoutsetting = () => {

    const { fetchRequest } = useMyContext()
    const labelSource = 'playout-settings'

    const baseURL = process.env.REACT_APP_Baseurl
    const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
    const indexApi = `${baseURL}/admin/admin-playout-setting-index`
    const updateApi = `${baseURL}/admin/admin-playout-setting-update`

    const [formData, setFormData] = useState({})
    const [formDataError, setFormDataError] = useState({})
    const [loading, setLoading] = useState(true)
    const [labelDisplay, setLabelDisplay] = useState()
    const combinedRef = useRef({title: null, unit : null, transcoding_resolution : null});
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [showOverlay, setShowOverlay] = useState(false);

    const handleInput = (e)  => {
        const {name, type, value } = e.target;

        if(type == "select-one" ){
            setFormData(prev => {
                const dataObj = {...prev?.updateData};
                dataObj[name] = value;

                return{
                    prev,
                    updateData: dataObj
                }
            })
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
            setFormData(prev => {
                const dataObj = {...prev?.updateData};
                dataObj['value'] = '';

                return{
                    prev,
                    updateData: dataObj
                }                
            })
        }
        if(type == 'text'){
            setFormData(prev => {
                const dataObj = {...prev?.updateData};
                dataObj[name] = value;

                return{
                    prev,
                    updateData: dataObj
                }
            })
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if(type == 'number'){
            setFormData(prev => {
                const dataObj = {...prev?.updateData};
                dataObj[name] = value;

                return{
                    prev,
                    updateData: dataObj
                }                
            })
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }
    }

    const fetchData = async () => {
        setLoading(true)
        await fetchRequest({
            method: 'GET',
            url: `${indexApi}`,
            params: {},
            data: {},
        })
        .then(response =>{
            if(response?.status){
                toast.success(response?.message)
                const durationUnits = ["Minutes", "Hour"]
                const updateData = {...response?.data}
                console.log("default res: " + updateData?.default_resolutions);
                
                updateData.defaultResulations = Array.isArray(updateData?.default_resolutions)
                ? updateData.default_resolutions.map(item => ({
                    label: item,
                    value: item
                }))
                : [];
                // updateData.defaultResulations = updateData?.default_resolutions.map(item => ({ name:item, value:item}));
                updateData.defaultUnits= durationUnits?.map(item => ({name:item,value:item}));
                setFormData((prev) => ({
                    updateData
                }))
                console.log("index api res from fetch " + JSON.stringify(updateData?.unit));
            }
        })
        .catch((error => {
            toast.error(error?.response?.data?.message || error.message)
        })).finally(()=>{
            setLoading(false)
        })
    }

    const labelFetch = async () => {
        setLoading(true)
        await fetchRequest({
            method: 'GET',
            url: `${labelApi}`,
            params: {},
            data: {},
        })
        .then(response => {
            if(response?.status){
                const labelResult = response?.label_management
                setLabelDisplay(labelResult)                
            }
        })
        .catch((error) => {
            toast.error(error?.response?.data?.message || error.message)
        })
        .finally(() => {
            setLoading(false)
        })
    }

    const formValidation = () => {
        let formIsValid = true;
        if (formData?.updateData?.unit == 'Hour' && formData?.updateData?.value > 24) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                value: "Unit less than or equal 24.",
            }));
            
            combinedRef.current['value'].focus()
            formIsValid = false;
        }

        if(!formData?.updateData?.value){
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                value: "value cannot be empty.",
            }));
            combinedRef.current['value'].focus()
            formIsValid = false;
        }
        if(!formData?.updateData?.unit){
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                unit: "unit cannot be empty.",
            }));
            combinedRef.current['unit'].focus()
            formIsValid = false;
        }
        if(!formData?.updateData?.resolutions || formData?.updateData?.resolutions.length === 0){
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                resolutions: "Transcoding resolution cannot be empty..",
            }));
            combinedRef.current['resolutions'].focus()
            formIsValid = false;
        }

        return formIsValid
    }

    const handleStore = async (e) => {
        e.preventDefault()
        if(formValidation()){
            await handleUpdate()
        }
    }

    const handleUpdate = async () => {
        setShowOverlay(true)

        const updateData = {
            value : formData?.updateData?.value,
            unit: formData?.updateData?.unit,
            resolutions: formData?.updateData?.resolutions?.map(r => r.value) || []
        }
        // console.log("update api req: " + JSON.stringify(updateData));
        
        try{
            const result = await fetchRequest({
                method: 'PATCH',
                url: `${updateApi}`,
                params: {},
                data: updateData,
            });

            if(result?.status){
                toast.success(result?.message || "Update successful");
                setWithOutRefresh(!withOutRefresh);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message;
            toast.error(errorMessage + (error?.response?.data?.error || ""));
        } finally {
            setShowOverlay(false);
        }
        
    }

    const handleMultiSelect = (selectedOptions, actionMeta) => {
        setFormData(prev => {
            const dataObj = {...prev?.updateData};
            dataObj[actionMeta?.name] = selectedOptions;

            return{
                prev,
                updateData: dataObj
            }
        })
        setFormDataError((prev) => ({
        ...prev,
        [actionMeta.name]: ""
        }))
    }

    useEffect(() => {
        fetchData()
        console.log("index api response: " + JSON.stringify(formData));        
    },[withOutRefresh])

    useEffect(() => {
        labelFetch()
    },[])

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    return (
        <>
            {showOverlay && (<Response_Processing />)}
            <AdminSaveHeader heading={labelDisplay?.[0]?.title} saveText={labelDisplay?.[1]?.title} saveMethod={handleStore} />
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[2]?.title} />
                        <MessageLabel text={labelDisplay?.[3]?.title } className="mandatorySimple" />
                        <AdminCustomSelect id="durationUnit" name="unit" value={formData?.updateData?.unit} options={formData?.updateData?.defaultUnits} onChange={handleInput} ref={(el) => (combinedRef.current.unit = el)} error={formDataError?.unit} defaultOptionName={"Select Duration Unit"} />
                        <MessageLabel text={labelDisplay?.[4]?.title } className="mandatorySimple" />
                        <AdminCustomInput id="value" type="number" name="value" value={formData?.updateData?.value} max={formData?.updateData?.unit === 'Hour' ? 24 : 1440} onChange={ e => { const maxVal = formData?.updateData?.unit === 'Hour' ? 24 : 1440; e.target.value = Math.min(Math.max(Number(e.target.value) || 0, 1), maxVal); handleInput(e)}} ref={(el) => (combinedRef.current.value = el)} error={formDataError?.value} placeHolder={"Value"} />
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[5]?.title } />
                        <MessageLabel text={labelDisplay?.[6]?.title } className="mandatorySimple" />
                        <Select options={formData?.updateData?.defaultResulations} isMulti name={'resolutions'} onChange={handleMultiSelect} value={formData?.updateData?.resolutions} ref={(el) => (combinedRef.current.resolutions = el)} error={formDataError?.resolutions} className="custom-select-multi custom-placeholder theme-text-color mb-3" />
                        {formDataError?.resolutions && (<MessageBox text={`${formDataError?.resolutions}`} classname='errorred mb-2 d-block' />)}
                    </Wrapper>
                </RightWrapper>
            </FormContainer>
        </>
    )
}

export default Playoutsetting